import { render, staticRenderFns } from "./TrackingPayPalModule.vue?vue&type=template&id=570768e8"
import script from "./TrackingPayPalModule.vue?vue&type=script&lang=js"
export * from "./TrackingPayPalModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports